import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

export const MainBox = styled.div`
  margin-top: ${SPACER.xlarge};
  padding: 0 ${SPACER.large};
  display: flex;
  flex-direction: column;
  gap: ${SPACER.small};

  ${MEDIA_QUERIES.mdUp} {
    padding: 0;
    max-width: 368px;
  }
`;
